import type { Store } from 'redux';

let reduxStore: Store | undefined;

/**
 * Called once from store.ts after configureStore.
 * Kept in this tiny module so store.ts does not import APIRequest (heavy graph: axios, i18n, etc.).
 */
export function bindReduxStore(store: Store): void {
  if (reduxStore !== undefined) {
    console.warn('bindReduxStore: Redux store already bound; ignoring duplicate call');
    return;
  }
  reduxStore = store;
}

export function getReduxStore(): Store | undefined {
  return reduxStore;
}
